export const LOCAL_STORAGE_KEYS = {
  WOO_JWT: 'WooJWT',
  COMPLETED_STEPS: 'completedSteps',
  LAST_QUERY: 'lastQuery',
  ON_SCREEN_TUTORIAL_PASSED: 'onScreenTutorialPassed',
  HANDS: 'hands',
  SUBTITLES_ON: 'subtitlesOn',
  PLAYBACK_RATE_ON: 'playbackRateOn',
  PLAYBACK_RATE: 'playbackRate',
  DEV_MODE: 'devMode',
  NEW_VIDEO_SOURCE: 'newVideoSource',
};

export const COLORS = {
  lightBlue: '#E5E5E5',
};

export const LINKS = {
  SHOPIFY_KITS: 'https://thewoobles.com/collections/crochet-amigurumi-kits',
};

export const HANDS = {
  RIGHT: 'right',
  LEFT: 'left',
};

export const CHARACTER_LIMITS = {
  LARGE_TEXT: 80,
  SMALL_TEXT: 600,
};

export const OVERLAY_SIZE = {
  L: 'Large',
  M: 'Medium',
  S: 'Small',
};

export const PASSCODE_RESPONSES = {
  // eslint-disable-next-line
  BAD_REG_CODE: "Hm, we don't recognize that. Doublecheck any U's and V's, or 8's and B's and try again.",
  // eslint-disable-next-line
  LOCKED_CODE: "This code's been locked. Reach out to help@thewoobles.com with your email and order number for help.",
  WRONG_KIT:
    // eslint-disable-next-line
    "It looks like you've typed in a code for another kit, please make sure the card you have matches the Wooble on this page.",
};

export const GUIDES = {
  STEVE_THE_FRANKENSTEIN: {
    id: 'recx2QtYcBRnqcZP0',
  },
};
